export function getRealTimeLiterals(t: any) {
    return {
      title: t("getRealTimeLiterals.title"),
      departure:t("getRealTimeLiterals.departure"),
      arrival:t("getRealTimeLiterals.arrival"),
      button:t("getRealTimeLiterals.button"),
      titleError:t("getRealTimeLiterals.titleError"),
      infoError: t("getRealTimeLiterals.infoError"),
  
    };
  }


  export function getTrainIncidentsLiterals(t: any) {
    return {
      title: t("getTrainIncidentsLiterals.title"),
      button:t("getRealTimeLiterals.button"),
  
    };
  }




  